import { isNativeApp } from '../utils/platform';

/**
 * In-app review prompt service.
 * Uses the native SKStoreReviewController on iOS to show a review dialog.
 * iOS limits this to 3 displays per 365-day period automatically.
 */

const GAMES_COMPLETED_KEY = 'wsle:gamesCompleted';
const REVIEW_PROMPTED_KEY = 'wsle:reviewPrompted';

/** Number of completed games before first review prompt */
const PROMPT_AFTER_GAMES = 5;

function getGamesCompleted(): number {
  try {
    return parseInt(localStorage.getItem(GAMES_COMPLETED_KEY) || '0', 10);
  } catch {
    return 0;
  }
}

function setGamesCompleted(count: number): void {
  try {
    localStorage.setItem(GAMES_COMPLETED_KEY, String(count));
  } catch { /* ignore */ }
}

function hasBeenPrompted(): boolean {
  try {
    return localStorage.getItem(REVIEW_PROMPTED_KEY) === 'true';
  } catch {
    return false;
  }
}

function markPrompted(): void {
  try {
    localStorage.setItem(REVIEW_PROMPTED_KEY, 'true');
  } catch { /* ignore */ }
}

/**
 * Call after each completed game (win or loss).
 * After the threshold is reached, presents the native review prompt once.
 */
export async function trackGameCompletionForReview(): Promise<void> {
  if (!isNativeApp()) return;
  if (hasBeenPrompted()) return;

  const count = getGamesCompleted() + 1;
  setGamesCompleted(count);

  if (count >= PROMPT_AFTER_GAMES) {
    try {
      const { CapgoInAppReview } = await import('@capgo/capacitor-in-app-review');
      await CapgoInAppReview.requestReview();
      markPrompted();
    } catch {
      // Review dialog may not appear — iOS controls this
    }
  }
}
